import { render, staticRenderFns } from "./DocumentDialog.vue?vue&type=template&id=9c2d5070"
import script from "./DocumentDialog.vue?vue&type=script&lang=js"
export * from "./DocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentDialog.vue?vue&type=style&index=0&id=9c2d5070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports